import { AxiosPromise } from 'axios';
import API from './base';

export type DepartmentsType = {
  id: string;
  name: string;
};

class DepartmentsApi extends API {
  getDepartments = (): AxiosPromise<DepartmentsType[]> => this.get('/api/web/v1/departments', {});
}

export default new DepartmentsApi();
